import modal from '@/utils/modal';
import { createAvatarConfigurator } from './index.js';
import createEl from '@/utils/createEl';

export default async function () {
  const m = modal.create();

  m.body.classList.add('gmf-ac-modal');

  const el = createEl('div', null, m.body, true);

  createAvatarConfigurator({
    selector: el,
  });
}
